export const CITATION_COPIED = 'Citation copied!'
export const CHECK_YOUR_PAPER = 'Next, check your paper for:'
export const ACCIDENTAL_PLAGIARISM = 'Accidental plagiarism'
export const GRAMMAR_ERRORS = 'Grammar errors'
export const CHECK_MY_PAPER = 'Check my paper'
export const GO_BACK_TO_CITATIONS = 'Go back to citations'
